<template>
  <full-width-slider
    pagination-label="Pagination"
    item-label="Picture"
    qa-hook="marketing-highlights-slider"
    :with-disclaimers="false"
  >
    <div class="vch-full-width-slider__list">
      <div
        v-for="(slide, slideIndex) in slides.CarouselSlide"
        :key="slideIndex"
        class="vch-full-width-slider__item"
        :aria-label="ariaLabel"
      >
        <div class="vch-card-highlight">
          <div v-if="slide.isVideo == true">
            <picture class="vch-card-highlight__image">
              <!-- NOSONAR --><video playinline autoplay muted loop>
                <source :src="slide.CarouselVideo" type="video/mp4" />
              </video>
            </picture>
          </div>
          <div v-else>
            <picture class="vch-card-highlight__image">
              <source :srcset="slide.CarouselImage.Src" media="(min-width: 1600px)" />
              <source :srcset="slide.CarouselImage.Src" media="(min-width: 1280px)" />
              <source :srcset="slide.CarouselImage.Src" media="(min-width: 1024px)" />
              <source :srcset="slide.CarouselImage.Src" media="(min-width: 720px)" />
              <img alt="Liftactiv B3 Kampagne" :src="slide.CarouselImage.Src" />
            </picture>
          </div>
          <div class="vch-card-highlight__content">
            <h2 class="vch-card-highlight__title mb-xs">
              <span class="heading-xl uppercase">LIFTACTIV</span>
              <span class="heading-xl-em uppercase">b3 anti-pigmentflecken creme</span>
            </h2>
            <p class="vch-card-highlight__description heading-md uppercase mb-lg">
              Sie wirkt dank des Anti-Pigmentflecken Wirkstoff-Komplexes und eines hohen
              Lichtschutzfaktors effektiv gegen Pigmentflecken.
            </p>
            <span>
              <a
                href="/alle-produkte/hautpflege/tagescremes/anti-aging/liftactiv-b3-anti-pigmentflecken-creme"
                data-analytics='{"domEvent":"click","locatorType":"className","locatorQuery":"mixed-slider-tag-uidc9994e58801e02624c1fc22c","timeduration":"","scrollratio":"","triggerOnExternalApiResponse":false,"eventName":"Mixed Slide Click","eventProperties":{"eventCategory":"homepage","eventLabel":"liftactiv b3 kampagne::/alle-produkte/hautpflege/tagescremes/anti-aging/liftactiv-b3-anti-pigmentflecken-creme","eventAction":"select::slider navigation","event":"uaevent","ecommerce":"undefined","event_name":"slider_button_click","cta_name":"liftactiv b3 kampagne","link_url":"/alle-produkte/hautpflege/tagescremes/anti-aging/liftactiv-b3-anti-pigmentflecken-creme","module_name":"mixed content slider"}}'
                class="button -primary --small mixed-slider-tag-uidc9994e58801e02624c1fc22c"
                >Mehr erfahren</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </full-width-slider>
</template>

<script>
export default {
  name: 'banner-mixed-content-sliders',
  props: {
    slides: {
      type: Object,
      required: true,
    },
    withDisclaimers: {
      type: Boolean,
      required: false,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      carouselidentifier: `carousel-${Date.now}`,
      isDragging: false,
    };
  },
  mounted() {
    ///
  },
  methods: {
    ///
  },
};
</script>
